<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import { initAnalytics } from '@/lib/analytics';

// Loads gtag when a measurement id was built in, and does nothing otherwise —
// which is every local and CI build.
onMounted(initAnalytics);
</script>

<template>
  <RouterView />
</template>
